import { Injectable } from '@angular/core';

// Espelha o ícone declarado em src/index.html (asset listado em angular.json).
const DEFAULT_FAVICON = 'favicon.ico';
const DEFAULT_FAVICON_TYPE = 'image/x-icon';

/**
 * APR-3347 — o login hospedado em app.aprova.com.br servia sempre o
 * favicon.ico da Aprova, ignorando o `faviconUrl` da cidade (que o domínio
 * personalizado já respeita). Aqui a tag `link[rel~=icon]` do index.html é
 * reescrita conforme a cidade da rota; sem cidade ou sem favicon configurado,
 * volta ao ícone padrão.
 */
@Injectable({ providedIn: 'root' })
export class FaviconService {
  update(url: string | null | undefined): void {
    const link = this._getOrCreateIconLink();

    if (url) {
      // O favicon da cidade costuma ser PNG; manter type="image/x-icon" do
      // index.html anunciaria um formato que não corresponde ao arquivo.
      link.removeAttribute('type');
      link.href = url;
      return;
    }

    link.type = DEFAULT_FAVICON_TYPE;
    link.href = DEFAULT_FAVICON;
  }

  private _getOrCreateIconLink(): HTMLLinkElement {
    const existing = document.querySelector<HTMLLinkElement>(
      "link[rel~='icon']"
    );

    if (existing) {
      return existing;
    }

    const link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);

    return link;
  }
}
